export const DISCONTINUATION_LETTER = 'discontinuationLetter';
